import { Box, Button, Tabs, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor } from 'assets/styles/_palette';

export const Profile = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 40 }),
	margin: '0 auto',
	width: '100%',
	height: '100%',
	'@media (max-width: 1536px)': {
		padding: '28px 0',
	},
});

export const SubmitButton = styled(Button)({
	marginTop: '40px',
	padding: '10px 16px',
	width: '100%',
	borderRadius: '8px',
	background: '#4786FF',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
	color: '#FFF',
	'&.Mui-disabled': {
		background: '#B5CFFF',
		color: '#FFF',
	},
});

export const TabContent = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 40 }),
	height: '100%',
	width: '100%',
});

export const TabsButtons = styled(Tabs)({
	'& .MuiTabs-flexContainer': {
		...flexMixin({ gap: 12 }),

		'& button': {
			boxSizing: 'border-box',
			padding: '8px 16px',
			textTransform: 'none',
			color: regularTextColor,
			fontSize: '16px',
			fontWeight: '400',
			lineHeight: '150%',
			letterSpacing: '0.15px',
			borderRadius: '8px',

			'&.Mui-selected': {
				background: '#ECF3FF',
				color: '#4786FF',
				fontWeight: '700',
			},
		},
	},

	'& .MuiTabs-indicator': {
		display: 'none',
	},
});
